export default __webpack_public_path__ + "static/media/logo-white-transparent.9f93d071.png";